import React, { useEffect, useState } from 'react';
import { CheckCircle, AlertTriangle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

// Live FAA delay status chip for an airport (used on guide pages)
export default function AirportDelayBadge({ code, className = '' }) {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    let cancel = false;
    (async () => {
      try {
        const r = await fetch(`${API}/airport/delays/${code.toLowerCase()}`);
        if (r.ok && !cancel) setStatus(await r.json());
      } catch {
        /* silent — badge just doesn't render */
      }
    })();
    return () => { cancel = true; };
  }, [code]);

  if (!status) return null;

  const mins = Math.round((status.delay_secs || 0) / 60);
  const isDelayed = status.color !== 'green' && mins > 0;

  return (
    <span
      data-testid={`airport-delay-badge-${code}`}
      title={status.reason || undefined}
      className={`inline-flex items-center gap-1.5 text-xs font-medium px-3 py-1 rounded-full ${
        !isDelayed
          ? 'bg-emerald-50 text-emerald-700 border border-emerald-100'
          : status.color === 'red'
            ? 'bg-rose-50 text-rose-700 border border-rose-100'
            : 'bg-amber-50 text-amber-700 border border-amber-100'
      } ${className}`}
    >
      {!isDelayed ? (
        <>
          <CheckCircle className="w-3.5 h-3.5" />
          No FAA delays right now
        </>
      ) : (
        <>
          <AlertTriangle className="w-3.5 h-3.5" />
          FAA delays now — avg {mins} min
        </>
      )}
    </span>
  );
}
